import request from '@utils/request'
import gateway from '@enum/gateway'

export const getButtonsAuth = () =>
  request.fetch(gateway.essentialService + '/v1/api/auth/button')

export const getMenus = () =>
  request.fetch(gateway.essentialService + '/v1/api/auth/application')
